import { useIsMobile } from 'utils/useIsMobile'
import { Activity, IconNextContainer, MobileRowWrapper, RowWrapper, Td } from './styles'
import { IconButtonNext } from 'components/Icons/IconButtonNext'
import { DisplayEvent } from './util'
import { getDisplayTimestamp } from 'utils/helpers'

interface Props {
  isLast: boolean
  handleEventRowClick: (event: DisplayEvent) => void
  event: DisplayEvent
}

export const LpRow = ({ isLast, event, handleEventRowClick }: Props) => {
  const isMobile = useIsMobile()

  return isMobile ? (
    <MobileRowWrapper $isLast={isLast} onClick={() => handleEventRowClick(event)}>
      <Td variant="caption" style={{ flexBasis: '45%', flexDirection: 'column', justifyContent: 'center' }}>
        <span style={{ width: 100, textAlign: 'left', marginRight: 'auto' }}>
          {getDisplayTimestamp(event.timestampMs)}
        </span>
      </Td>
      <Td variant="caption" fontWeight="medium" style={{ flexBasis: '45%' }}>
        <Activity $type={event.action}>{event.action}</Activity>
      </Td>
      <Td variant="caption" fontWeight="medium" style={{ flexBasis: '10%' }}>
        <IconNextContainer>
          <IconButtonNext width={30} height={30} />
        </IconNextContainer>
      </Td>
    </MobileRowWrapper>
  ) : (
    <RowWrapper
      $isLast={isLast}
      href={`https://suivision.xyz/txblock/${event.transactionDigest}`}
      target="_blank"
      rel="noreferrer"
    >
      <Td variant="body"> {getDisplayTimestamp(event.timestampMs)}</Td>
      <Td variant="caption" fontWeight="medium">
        <Activity $type={event.action}>{event.action}</Activity>
      </Td>
      <Td variant="body" style={{ flexBasis: 600 }}>
        {event.details}
      </Td>
      <IconNextContainer>
        <IconButtonNext />
      </IconNextContainer>
    </RowWrapper>
  )
}
